import { OAuth2AuthCodeCallback } from "@/auth";
import { createFileRoute } from "@tanstack/react-router";

import { z } from "zod";

const oauth2CallbackSearchParamsSchema = z.object({
  state: z.string().optional(),
});

export const Route = createFileRoute("/_unauthenticated/oauth2/callback")({
  component: OAuth2AuthCodeCallback,
  validateSearch: oauth2CallbackSearchParamsSchema,
});
